import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import SendIcon from '@mui/icons-material/Send';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import { SourceKind } from '../../../services/dmarcApi';

const META: Record<
  SourceKind,
  {
    label: string;
    color: 'default' | 'primary' | 'success' | 'info' | 'warning' | 'error';
    icon: React.ReactElement;
    tooltip: string;
  }
> = {
  direct: {
    label: 'Direct',
    color: 'success',
    icon: <SendIcon fontSize="small" />,
    tooltip:
      'DKIM aligned + SPF aligned. End-to-end clean send from our own sender.',
  },
  forwarded: {
    label: 'Forwarded',
    color: 'info',
    icon: <ForwardToInboxIcon fontSize="small" />,
    tooltip:
      'DKIM aligned but SPF failed — classic forwarder pattern (Gmail / Outlook auto-forward etc.). Mail still delivered via DKIM; not a problem.',
  },
  unsigned: {
    label: 'Unsigned',
    color: 'warning',
    icon: <HelpOutlineIcon fontSize="small" />,
    tooltip:
      'SPF aligned but DKIM missing/failed. Likely our sender on a path that didn\'t DKIM-sign.',
  },
  unauthorized: {
    label: 'Unauthorized',
    color: 'error',
    icon: <GppMaybeIcon fontSize="small" />,
    tooltip:
      'Neither DKIM nor SPF aligned. Spoofing, misconfigured 3rd-party sender, or shadow IT.',
  },
};

interface Props {
  kind?: SourceKind | null;
  size?: 'small' | 'medium';
}

const SourceKindChip: React.FC<Props> = ({ kind, size = 'small' }) => {
  if (!kind || !(kind in META)) return null;
  const m = META[kind];
  return (
    <Tooltip title={m.tooltip} arrow>
      <Chip
        size={size}
        variant="outlined"
        color={m.color}
        icon={m.icon}
        label={m.label}
      />
    </Tooltip>
  );
};

export default SourceKindChip;
